// @flow
import type { SampleList } from "../../lib/OnlineTypes";
import React from "react";
import Samples from "./Samples";
import SampleSearch from "./SampleSearch";
import Link from "../Link";
// import { DefaultPaddedContainerNoShadow } from "./Theme";

type Props = {
  company_id: ?number,
  canFindCompany: ?boolean,
  clientView: ?boolea,
  sample_id: ?number,
  fixedSearchParameters: ?object,
  minimiseSearch: ?boolean,
  runSearch: ?boolean,
  jobId: ?number,
  clearDates: ?boolean,
  laboratory_company_id: ?number,
};

type State = {
  sample_list: SampleList,
};

export default class AdvancedSampleSearch extends React.Component<Props, State> {
  static defaultProps = {
    clientView: false,
    minimiseSearch: false,
    runSearch: false,
    jobId: null,
    clearDates: false,
  };

  state = {
    sample_list: null,
    minimiseSearch: this.props.minimiseSearch,
  };

  setSampleList = (sample_list: SampleList) =>
    this.setState({
      sample_list,
    });

  render() {
    const {
      company_id,
      canFindCompany,
      clientView,
      sample_id,
      fixedSearchParameters,
      jobId,
      runSearch,
      clearDates,
      laboratory_company_id,
    } = this.props;
    const { sample_list, minimiseSearch } = this.state;
    return (
      <div>
        {minimiseSearch && (
          <p style={{ marginTop: 10, marginBottom: -10, paddingBottom: 0 }}>
            <Link onClick={() => this.setState({ minimiseSearch: false })}>
              <i className="fa fa-caret-down" />
              &nbsp;&nbsp; Show Advanced Search
            </Link>
          </p>
        )}
        <div style={{ display: minimiseSearch ? "none" : "inherit" }}>
          <SampleSearch
            ref={(ref) => (this.searcher = ref)}
            company_id={company_id}
            onSearch={this.setSampleList}
            canFindCompany={canFindCompany}
            clientView={clientView}
            initialSampleId={sample_id}
            fixedSearchParameters={fixedSearchParameters}
            clearDates={clearDates}
            runSearch={runSearch}
            laboratoryCompanyId={laboratory_company_id}
          />
        </div>
        {sample_list && (
          <div style={{ marginTop: 20 }}>
            <Samples
              sample_list={sample_list}
              company_id={company_id}
              clientView={clientView}
              showAttributes={false}
              reloadData={() => this.searcher.findSamples()}
              toolbarOptions={{ jobId }}
            />
          </div>
        )}
      </div>
    );
  }
}
